import React, { forwardRef } from 'react'
// import { css } from '@emotion/css'
import { Tree } from '@ow/comps'

const Render = function (
  { checkable = false, onSelect, datas = [], selectedKeys, updateCheckedKeys },
  ref
) {
  const onCheck = (keys, { checked, checkedNodes, node }) => {
    console.log(keys, 'keys', ref)
    console.log(checked, 'keys')
    console.log(checkedNodes, 'keys')
    console.log(node, 'keys')
    if (updateCheckedKeys) {
      updateCheckedKeys(keys, node)
    }
  }

  return (
    <Tree
      // className={treeStyle}
      data={datas}
      label="title"
      ckey="id"
      showLine={false}
      checkable={checkable}
      selectedKeys={selectedKeys}
      onSelect={onSelect}
      defaultExpandedKeys={[]}
      defaultSelectedKeys={[]}
      onCheck={onCheck}
      setExtData={(item) => {
        return { label: item.title }
      }}
    />
  )
}

export default forwardRef(Render)
